(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bar = document.querySelector('[data-countdown-bar]');
    if (!bar) return;

    // ── Şema değerlerini oku ──────────────────────────────────────────────
    const cfg = {
      start: bar.getAttribute('data-start') || '',
      end: bar.getAttribute('data-end') || '',
      loop: bar.getAttribute('data-loop') === 'true',
      windowDays: parseInt(bar.getAttribute('data-window-days') || '0', 10),
      hideAnnouncement: bar.getAttribute('data-hide-announcement') === 'true',
      showDeadline: bar.getAttribute('data-show-deadline') === 'true',
    };

    const valueEls = {};
    bar.querySelectorAll('[data-unit]').forEach((unit) => {
      const key = unit.getAttribute('data-unit-key');
      const valueEl = unit.querySelector('[data-value]');
      const labelEl = unit.querySelector('[data-label]');
      if (!key || !valueEl || !labelEl) return;

      valueEls[key] = { valueEl, labelEl };

      // Unit label'ları şema yerine yerel olarak burada tutuluyor —
      // home_sicatron'daki UNIT_LABELS ile birebir eşlenir.
      const labels = { days: 'Tage', hours: 'Std.', minutes: 'Min.', seconds: 'Sek.' };
      labelEl.textContent = labels[key];
    });

    const pad2 = (n) => String(n).padStart(2, '0');

    // useCountDown.compute() — React'teki mantığın birebir vanilla karşılığı.
    function compute(now) {
      const startMs = Date.parse(cfg.start);
      const EMPTY = {
        days: 0, hours: 0, minutes: 0, seconds: 0,
        isActive: false, hasEnded: false,
      };

      if (cfg.loop) {
        const windowMs = cfg.windowDays * 86400000;
        if (Number.isNaN(startMs) || windowMs <= 0) return EMPTY;
        if (now < startMs) return EMPTY;

        const blockIndex = Math.floor((now - startMs) / windowMs);
        const windowEndMs = startMs + blockIndex * windowMs + windowMs;
        const remainingMs = windowEndMs - now;

        return {
          days: Math.floor(remainingMs / 86400000),
          hours: Math.floor((remainingMs % 86400000) / 3600000),
          minutes: Math.floor((remainingMs % 3600000) / 60000),
          seconds: Math.floor((remainingMs % 60000) / 1000),
          isActive: true,
          hasEnded: false,
        };
      }

      const endMs = Date.parse(cfg.end);
      if (Number.isNaN(startMs) || Number.isNaN(endMs)) return EMPTY;
      if (now < startMs) return EMPTY;
      if (now >= endMs) return { ...EMPTY, hasEnded: true };

      const remainingMs = endMs - now;
      return {
        days: Math.floor(remainingMs / 86400000),
        hours: Math.floor((remainingMs % 86400000) / 3600000),
        minutes: Math.floor((remainingMs % 3600000) / 60000),
        seconds: Math.floor((remainingMs % 60000) / 1000),
        isActive: true,
        hasEnded: false,
      };
    }

    let prevActive = null;

    // Bar yüksekliğindeki oynamalara karşı offset'i dinamik ölç
    function measureHeight() {
      if (bar && !bar.hidden) {
        document.documentElement.style.setProperty('--countdown-h', bar.offsetHeight + 'px');
      }
    }

    window.addEventListener('resize', measureHeight);

    function applyState(state) {
      const isActive = state.isActive;

      // Bar görünürlüğü
      bar.hidden = !isActive;

      // Body sınıfı + announcement-bar gizleme — yalnızca durum değişince
      if (prevActive !== isActive) {
        document.body.classList.toggle('countdown-active', isActive);

        if (cfg.hideAnnouncement) {
          const announcement = document.querySelector('[data-announcement-bar]');
          if (announcement) announcement.hidden = isActive;
        }

        prevActive = isActive;
      }

      measureHeight();

      if (!isActive) return;

      // sayaç değerlerini güncelle
      Object.keys(valueEls).forEach((key) => {
        const val = state[key];
        valueEls[key].valueEl.textContent = pad2(val != null ? val : 0);
      });
    }

    function tick() {
      applyState(compute(Date.now()));
    }

    // İlk çalıştırma: announcement-bar (layout'ta daha sonra render edilen başka
    // bir section) DOM'a eklenmeden önce bu satır içi script çalışabilir. İlk
    // uygulamayı DOM hazır olunca yap; aksi halde announcement gizlenmez.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tick);
    } else {
      tick();
    }

    window.setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const el = document.querySelector('[data-typewriter]');
    if (!el) return;

    const prefix = el.getAttribute('data-typewriter-prefix') || '';
    const brand = el.getAttribute('data-typewriter-brand') || '';
    const suffix = el.getAttribute('data-typewriter-suffix') || '';
    const total = prefix.length + brand.length + suffix.length;
    const label = prefix + brand + suffix;

    el.setAttribute('aria-label', label);
    el.innerHTML =
      '<span data-typewriter-prefix></span>' +
      '<span class="features__title-brand" data-typewriter-brand></span>' +
      '<span data-typewriter-suffix></span>' +
      '<span class="features__title-cursor" aria-hidden="true"></span>';

    const prefixEl = el.querySelector('[data-typewriter-prefix]');
    const brandEl = el.querySelector('[data-typewriter-brand]');
    const suffixEl = el.querySelector('[data-typewriter-suffix]');

    let started = false;

    function render(count) {
      let remaining = count;
      const p = Math.min(remaining, prefix.length);
      prefixEl.textContent = prefix.slice(0, p);
      remaining -= p;

      const b = Math.min(remaining, brand.length);
      brandEl.textContent = brand.slice(0, b);
      remaining -= b;

      suffixEl.textContent = suffix.slice(0, remaining);
    }

    function start() {
      if (started) return;
      started = true;

      let count = 0;
      function tick() {
        count += 1;
        render(count);
        if (count < total) setTimeout(tick, 90);
      }
      tick();
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            observer.disconnect();
            start();
          }
        });
      },
      { threshold: 0.3 },
    );

    observer.observe(el);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    window.SicatronHeader = window.SicatronHeader || {};

    // ── Auto-hide header (scroll down'da gizle, hafif yukarıda göster) ──
    const siteHeader = document.querySelector('header.site-header');
    if (siteHeader) {
      let lastScrollY = window.scrollY;
      let ticking = false;

      function updateHeader() {
        const currentY = window.scrollY;
        const delta = currentY - lastScrollY;
        const headerHeight = siteHeader.offsetHeight || 80;

        // Sayfa en üstündeyken her zaman görünür.
        if (currentY <= 0) {
          siteHeader.classList.remove('is-hidden');
        } else if (delta < 0) {
          // Yukarı kaydırma (hafif bile olsa): her zaman göster.
          siteHeader.classList.remove('is-hidden');
        } else if (delta > 4 && currentY > headerHeight) {
          // Belirgin aşağı kaydırma: gizle (titremeyi önlemek için küçük eşik).
          siteHeader.classList.add('is-hidden');
        }

        lastScrollY = currentY;
        ticking = false;
      }

      window.addEventListener('scroll', () => {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(updateHeader);
        }
      }, { passive: true });
    }

    // ── Mobile drawer ────────────────────────────────────────────────
    const drawer = document.querySelector('[data-drawer]');
    const overlay = document.querySelector('[data-drawer-overlay]');
    const openButtons = document.querySelectorAll('[data-drawer-open]');
    const closeButtons = document.querySelectorAll('[data-drawer-close], [data-drawer-overlay]');

    function setDrawer(open) {
      if (!drawer || !overlay) return;
      drawer.classList.toggle('is-open', open);
      overlay.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
    }

    openButtons.forEach((b) => b.addEventListener('click', () => setDrawer(true)));
    closeButtons.forEach((b) => b.addEventListener('click', () => setDrawer(false)));

    // ── Mobile accordions ────────────────────────────────────────────
    document.querySelectorAll('[data-accordion]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const panel = btn.nextElementSibling;
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        if (panel) panel.hidden = isOpen;
      });
    });

    // ── Search modal ─────────────────────────────────────────────────
    const searchModal = document.querySelector('[data-search-modal]');
    const searchInput = document.querySelector('[data-search-input]');
    const searchQuick = document.querySelector('[data-search-quick]');
    const searchResults = document.querySelector('[data-search-results]');
    const searchClear = document.querySelector('[data-search-clear]');
    let searchDebounce;

    function setSearch(open) {
      if (!searchModal) return;
      searchModal.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        setTimeout(() => searchInput && searchInput.focus(), 80);
      } else {
        if (searchInput) searchInput.value = '';
        if (searchQuick) searchQuick.hidden = false;
        if (searchResults) searchResults.hidden = true;
      }
    }

    document.querySelectorAll('[data-search-open]').forEach((b) =>
      b.addEventListener('click', () => setSearch(true))
    );
    searchModal && searchModal.addEventListener('click', (e) => {
      if (e.target === searchModal) setSearch(false);
    });
    searchClear && searchClear.addEventListener('click', () => {
      if (searchInput) { searchInput.value = ''; searchInput.focus(); }
      if (searchQuick) searchQuick.hidden = false;
      if (searchResults) searchResults.hidden = true;
    });
    searchInput && searchInput.addEventListener('input', () => {
      clearTimeout(searchDebounce);
      const q = searchInput.value.trim();
      if (q.length < 2) {
        if (searchQuick) searchQuick.hidden = false;
        if (searchResults) searchResults.hidden = true;
        return;
      }
      searchDebounce = setTimeout(() => {
        fetch('/search/suggest.json?resources[type]=product&resources[limit]=4&q=' + encodeURIComponent(q) + '&resources[options][fields]=title,body,product_type,variants.title')
          .then((r) => r.json())
          .then((data) => {
            const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            if (!searchResults) return;
            searchResults.innerHTML = '';
            if (!products.length) {
              searchResults.innerHTML = '<p style="padding:16px 0;color:#9ca3af;font-size:14px;">Keine Ergebnisse gefunden</p>';
            } else {
              products.forEach((p) => {
                const a = document.createElement('a');
                a.href = p.url;
                a.style.cssText = 'display:flex;align-items:center;gap:12px;padding:8px 0;border-top:1px solid #f3f4f6;';
                a.innerHTML =
                  '<span style="width:40px;height:40px;border-radius:8px;background:#f3f4f6;overflow:hidden;flex-shrink:0;display:flex;align-items:center;justify-content:center;">' +
                    (p.image ? '<img src="' + p.image + '" alt="" style="width:100%;height:100%;object-fit:cover;">' : '') +
                  '</span>' +
                  '<span style="flex:1;min-width:0;"><span style="display:block;font-size:14px;color:#1f2937;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + p.title + '</span>' +
                  '<span style="font-size:12px;color:#9ca3af;">' + (p.price ? p.price : '') + '</span></span>';
                searchResults.appendChild(a);
              });
            }
            if (searchQuick) searchQuick.hidden = true;
            searchResults.hidden = false;
          })
          .catch(() => {});
      }, 200);
    });

    // ESC closes search
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') setSearch(false);
    });

    // ── Cart count (AJAX) ────────────────────────────────────────────
    const cartCount = document.querySelector('[data-cart-count]');
    if (cartCount) {
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          const n = cart.item_count || 0;
          cartCount.textContent = n;
          cartCount.setAttribute('data-has-items', n > 0 ? 'true' : 'false');
        })
        .catch(() => {});
    }

    // ── Store reviews modal ──────────────────────────────────────────
    const reviewsBadges = document.querySelectorAll('[data-reviews-open]');
    const reviewsModal = document.querySelector('[data-reviews-modal]');
    if (reviewsBadges.length && reviewsModal) {
      const reviewsBody = reviewsModal.querySelector('[data-reviews-body]');
      const reviewsTemplate = reviewsModal.querySelector('[data-reviews-template]');
      let reviewsInjected = false;
      let borrowedReview = null;
      let borrowedOrigin = null;

      function closeReviews() {
        reviewsModal.classList.remove('is-open');
        reviewsModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (borrowedReview && borrowedOrigin) {
          borrowedOrigin.parent.insertBefore(borrowedReview, borrowedOrigin.next);
          borrowedReview = null;
          borrowedOrigin = null;
        }
      }

      function openReviews() {
        reviewsModal.classList.add('is-open');
        reviewsModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        if (!reviewsBody) return;
        const existing = document.getElementById('looxReviews');
        if (existing && !reviewsBody.contains(existing)) {
          borrowedReview = existing;
          borrowedOrigin = { parent: existing.parentNode, next: existing.nextSibling };
          reviewsBody.appendChild(existing);
        } else if (!existing && !reviewsInjected && reviewsTemplate && reviewsTemplate.content) {
          reviewsBody.appendChild(reviewsTemplate.content.cloneNode(true));
          reviewsInjected = true;
        }
      }

      reviewsBadges.forEach((badge) => badge.addEventListener('click', openReviews));
      reviewsModal.querySelectorAll('[data-reviews-close]').forEach((b) =>
        b.addEventListener('click', closeReviews)
      );
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeReviews();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-hero-slideshow]');
    if (!root) return;

    const second = root.querySelector('.hero__img--second');
    if (!second) return;

    let active = false;
    setInterval(() => {
      active = !active;
      root.classList.toggle('is-animating', active);
    }, 4400);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-flow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-home-flow]');
    if (!root) return;

    const row = root.querySelector('[data-home-flow-row]');
    if (!row) return;

    const nodes = () => Array.from(row.querySelectorAll('[data-home-flow-node]'));

    function measure() {
      const rowRect = row.getBoundingClientRect();
      const centers = nodes().map((el) => {
        const r = el.getBoundingClientRect();
        return {
          x: r.left + r.width / 2 - rowRect.left,
          y: r.top + r.height / 2 - rowRect.top,
        };
      });

      // Mevcut çizgileri temizle (tekrar eklenmesin).
      row.querySelectorAll('[data-home-flow-line]').forEach((el) => el.remove());

      for (let i = 0; i < centers.length - 1; i += 1) {
        const a = centers[i];
        const b = centers[i + 1];
        if (!a || !b) continue;

        const line = document.createElement('span');
        line.setAttribute('data-home-flow-line', '');
        line.className = 'home-flow__line';
        line.style.left = a.x + 'px';
        line.style.width = Math.max(0, b.x - a.x) + 'px';
        // İki düğüm merkezinin dikey ortası → her iki segment aynı hizada kalır.
        line.style.top = ((a.y + b.y) / 2) + 'px';
        row.appendChild(line);
      }
    }

    measure();
    window.addEventListener('resize', measure);

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(measure);
      ro.observe(row);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  'use strict';

  var root = document.getElementById('cart-page-root');
  if (!root) return;

  var isUpdating = false;

  /* ── Para biçimlendirme ──────────────────────────────────────────── */
  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  /* ── Satır görünümünü güncelle ───────────────────────────────────── */
  function updateLineDisplay(lineEl, lineData, newQty) {
    var priceEl   = lineEl.querySelector('[data-line-price]');
    var compareEl = lineEl.querySelector('[data-line-compare]');
    var savingsEl = lineEl.querySelector('[data-line-savings]');
    var perUnitEl = lineEl.querySelector('[data-line-per-unit]');
    var qtyDisp   = lineEl.querySelector('[data-qty-display]');
    var minusBtn  = lineEl.querySelector('[data-stepper-minus]');
    var plusBtn   = lineEl.querySelector('[data-stepper-plus]');

    if (qtyDisp)  qtyDisp.textContent = String(newQty);
    if (minusBtn) {
      minusBtn.disabled = newQty <= 1;
      minusBtn.dataset.qty = String(newQty);
    }
    if (plusBtn) plusBtn.dataset.qty = String(newQty);

    if (priceEl && lineData) {
      priceEl.textContent = formatMoney(lineData.final_line_price);
    }
    if (lineData && lineData.compare_at_price && lineData.compare_at_price > lineData.price) {
      if (compareEl) compareEl.textContent = formatMoney(lineData.compare_at_price * newQty);
      if (savingsEl) savingsEl.textContent = 'Sie sparen ' + formatMoney((lineData.compare_at_price - lineData.price) * newQty);
    }
    if (perUnitEl) perUnitEl.style.display = newQty > 1 ? '' : 'none';
  }

  /* ── Özet panelini güncelle ──────────────────────────────────────── */
  function updateSummary(cartData) {
    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    var totalEl    = document.querySelector('[data-cart-total]');
    var countEl    = document.querySelector('[data-cart-title-count]') || document.getElementById('cart-title-count');
    var headerBadge = document.querySelector('.header__cart-count');

    if (subtotalEl) subtotalEl.textContent = formatMoney(cartData.total_price);
    document.querySelectorAll('[data-cart-total]').forEach(function (el) {
      el.textContent = formatMoney(cartData.total_price);
    });
    if (countEl)    countEl.textContent    = '(' + cartData.item_count + ' Artikel)';

    if (headerBadge) {
      headerBadge.textContent = String(cartData.item_count);
      headerBadge.setAttribute('data-has-items', cartData.item_count > 0 ? 'true' : 'false');
    }
  }

  /* ── Boş sepet göster ───────────────────────────────────────────── */
  function showEmptyCart() {
    var layout    = document.getElementById('cart-layout');
    var titleCount = document.getElementById('cart-title-count');

    var mobileCheckout = document.querySelector('[data-cart-mobile-checkout]');
    if (titleCount) titleCount.remove();
    if (mobileCheckout) mobileCheckout.remove();
    if (layout) {
      layout.style.transition = 'opacity 0.3s ease';
      layout.style.opacity = '0';
      setTimeout(function () {
        layout.remove();
        var container = root.querySelector('.container');
        var emptyDiv = document.createElement('div');
        emptyDiv.className = 'cart-empty';
        emptyDiv.id = 'cart-empty';
        emptyDiv.innerHTML =
          '<div class="cart-empty__icon-wrap">' +
            '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
              '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/>' +
            '</svg>' +
          '</div>' +
          '<h2 class="cart-empty__title">Ihr Warenkorb ist leer</h2>' +
          '<p class="cart-empty__text">F\u00fcgen Sie Produkte hinzu, um zu beginnen!</p>' +
          '<a href="/collections/all" class="btn btn--dark cart-empty__cta">Weiter einkaufen</a>';
        if (container) container.appendChild(emptyDiv);
      }, 320);
    }
  }

  /* ── Satırı sil animasyonu ──────────────────────────────────────── */
  function animateRemoveLine(lineEl, callback) {
    lineEl.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
    lineEl.style.opacity = '0';
    lineEl.style.transform = 'translateX(-20px)';
    setTimeout(function () {
      lineEl.remove();
      if (callback) callback();
    }, 320);
  }

  /* ── AJAX sepet güncelleme ──────────────────────────────────────── */
  function cartChange(key, quantity) {
    if (isUpdating) return;
    isUpdating = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart error ' + res.status);
      return res.json();
    })
    .then(function (cartData) {
      updateSummary(cartData);

      var lineEl = document.querySelector('[data-cart-line="' + key + '"]');

      if (quantity === 0) {
        /* Ürünü DOM'dan kaldır */
        if (lineEl) {
          animateRemoveLine(lineEl, function () {
            if (cartData.item_count === 0) showEmptyCart();
          });
        } else if (cartData.item_count === 0) {
          showEmptyCart();
        }
      } else {
        /* Satır görünümünü güncelle */
        var updatedItem = null;
        if (cartData.items) {
          for (var i = 0; i < cartData.items.length; i++) {
            if (cartData.items[i].key === key) { updatedItem = cartData.items[i]; break; }
          }
        }
        if (lineEl) updateLineDisplay(lineEl, updatedItem, quantity);
      }
    })
    .catch(function (err) {
      console.error('[Cart] Güncelleme hatası:', err);
    })
    .finally(function () {
      isUpdating = false;
    });
  }

  /* ── Olay dinleyici (event delegation) ─────────────────────────── */
  root.addEventListener('click', function (e) {

    /* Minus stepper */
    var minusBtn = e.target.closest('[data-stepper-minus]');
    if (minusBtn) {
      var key  = minusBtn.dataset.key;
      var qty  = parseInt(minusBtn.dataset.qty || '1', 10);
      var newQty = Math.max(0, qty - 1);
      cartChange(key, newQty);
      return;
    }

    /* Plus stepper */
    var plusBtn = e.target.closest('[data-stepper-plus]');
    if (plusBtn) {
      var key2  = plusBtn.dataset.key;
      var qty2  = parseInt(plusBtn.dataset.qty || '1', 10);
      var newQty2 = qty2 + 1;
      cartChange(key2, newQty2);
      return;
    }

    /* Sil butonu */
    var removeBtn = e.target.closest('[data-remove-item]');
    if (removeBtn) {
      var key3 = removeBtn.dataset.key;
      cartChange(key3, 0);
      return;
    }
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  'use strict';

  /* ── Sort select ───────────────────────────────────────────────────── */
  var sortSelect = document.getElementById('col-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ── CollectionNavBar: aktif pill'i ortaya kaydır ──────────────────── */
  var activePill = document.querySelector('.col-nav-pill.is-active');
  if (activePill) {
    setTimeout(function () {
      activePill.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }, 100);
  }

  /* ── Mobil grid yoğunluğu ──────────────────────────────────────────── */
  var densityBtns = document.querySelectorAll('.col-density__btn');
  var grid = document.getElementById('col-products-grid');

  function setDensity(density) {
    if (!density) return;
    densityBtns.forEach(function (b) {
      var active = b.dataset.density === density;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    if (grid) {
      grid.setAttribute('data-mobile-density', density);
    }
  }

  densityBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setDensity(btn.dataset.density);
    });
  });

  /* Başlangıç: varsayılan 1 sütun */
  setDensity('1');

  /* ── Filter toggle ─────────────────────────────────────────────────── */
  var filterToggle = document.getElementById('col-filter-toggle');
  var filterPanel  = document.getElementById('col-filter-panel');

  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () {
      var isOpen = filterToggle.getAttribute('aria-expanded') === 'true';
      filterToggle.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      filterToggle.classList.toggle('is-active', !isOpen);
      filterPanel.hidden = isOpen;
      filterPanel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
    });
  }

  /* ── Client-side filter engine ─────────────────────────────────────── */
  var items        = Array.from(document.querySelectorAll('.col-product-item'));
  var countEl      = document.querySelector('[data-product-count]');
  var noResults    = document.getElementById('col-no-results');

  var priceMinInput  = document.querySelector('[data-price-min]');
  var priceMaxInput  = document.querySelector('[data-price-max]');
  var instockCheck   = document.querySelector('[data-filter-instock]');
  var tagBtns        = document.querySelectorAll('[data-filter-tag]');
  var resetBtns      = document.querySelectorAll('[data-filter-reset]');

  var activeTags = new Set();

  function applyFilters() {
    var priceMin = priceMinInput ? parseFloat(priceMinInput.value) || 0 : 0;
    var priceMax = priceMaxInput ? parseFloat(priceMaxInput.value) || Infinity : Infinity;
    var inStock  = instockCheck ? instockCheck.checked : false;

    var visible = 0;

    items.forEach(function (item) {
      var price     = parseFloat(item.dataset.price || '0');
      var available = item.dataset.available === 'true';
      var tagsStr   = item.dataset.tags || '';

      var priceOk  = price >= priceMin && price <= priceMax;
      var stockOk  = !inStock || available;
      var tagOk    = activeTags.size === 0 || (function () {
        var itemTags = tagsStr.split(',').map(function (t) { return t.trim(); });
        var found = false;
        activeTags.forEach(function (t) { if (itemTags.indexOf(t) !== -1) found = true; });
        return found;
      })();

      var show = priceOk && stockOk && tagOk;
      item.hidden = !show;
      if (show) visible++;
    });

    /* Sayacı güncelle */
    if (countEl) countEl.textContent = String(visible);

    /* Sonuç yok mesajı */
    if (noResults) noResults.hidden = visible > 0;
  }

  /* Fiyat inputs */
  [priceMinInput, priceMaxInput].forEach(function (input) {
    if (!input) return;
    input.addEventListener('input', applyFilters);
  });

  /* Stok checkbox */
  if (instockCheck) {
    instockCheck.addEventListener('change', applyFilters);
  }

  /* Tag pills */
  tagBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tag = btn.dataset.filterTag;
      if (activeTags.has(tag)) {
        activeTags.delete(tag);
        btn.classList.remove('is-active');
      } else {
        activeTags.add(tag);
        btn.classList.add('is-active');
      }
      applyFilters();
    });
  });

  /* Reset */
  resetBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (priceMinInput)  priceMinInput.value  = '';
      if (priceMaxInput)  priceMaxInput.value  = '';
      if (instockCheck)   instockCheck.checked = false;
      activeTags.clear();
      tagBtns.forEach(function (b) { b.classList.remove('is-active'); });
      applyFilters();
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  'use strict';

  /* ─── Data ─────────────────────────────────────────────────────────── */
  var variants = [];
  var images   = [];
  try {
    variants = JSON.parse(document.getElementById('pdp-variants-json').textContent);
    images   = JSON.parse(document.getElementById('pdp-images-json').textContent);
  } catch (e) {}

  var selectedOptions = (variants[0] && variants[0].options) ? variants[0].options.slice() : [];
  var currentVariantId = variants[0] ? variants[0].id : null;
  var currentQty = 1;

  /* ─── Helpers ───────────────────────────────────────────────────────── */
  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  function findVariant() {
    return variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selectedOptions[i]; });
    }) || null;
  }

  /* ─── Price / ATC update ────────────────────────────────────────────── */
  function updateForVariant(variant) {
    if (!variant) return;
    currentVariantId = variant.id;

    /* Select */
    var sel = document.getElementById('pdp-variant-select');
    if (sel) sel.value = String(variant.id);

    /* Price row */
    var priceEl   = document.querySelector('[data-pdp-price]');
    var compareEl = document.querySelector('[data-pdp-compare]');
    var saveEl    = document.querySelector('[data-pdp-save]');
    var discEl    = document.querySelector('[data-pdp-discount-badge]');

    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    var hasDisc = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (compareEl) {
      compareEl.style.display = hasDisc ? '' : 'none';
      if (hasDisc) compareEl.textContent = 'Statt ' + formatMoney(variant.compare_at_price);
    }
    if (saveEl) {
      saveEl.style.display = hasDisc ? '' : 'none';
      if (hasDisc) saveEl.textContent = 'Spare ' + formatMoney(variant.compare_at_price - variant.price);
    }
    if (discEl) {
      discEl.style.display = hasDisc ? '' : 'none';
      if (hasDisc) discEl.textContent = '-' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%';
    }

    /* ATC button */
    var atcBtn   = document.getElementById('pdp-atc-btn');
    var atcLabel = document.getElementById('pdp-atc-label');
    var atcPrice = document.getElementById('pdp-atc-price');

    if (atcBtn) atcBtn.disabled = !variant.available;
    if (atcLabel) atcLabel.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
    if (atcPrice) atcPrice.textContent = formatMoney(variant.price * currentQty);

    /* Gallery: swap main image if variant has own image */
    if (variant.img_url) {
      swapMainImage(variant.img_url, null);
    }
  }

  /* ─── Gallery ───────────────────────────────────────────────────────── */
  var mainImg  = document.getElementById('pdp-main-img');
  var thumbBtns = Array.from(document.querySelectorAll('.pdp__thumb'));
  var currentThumbIdx = 0;

  function swapMainImage(src, idx) {
    if (mainImg) mainImg.src = src;
    thumbBtns.forEach(function (b) { b.classList.remove('is-active'); });
    if (idx !== null && thumbBtns[idx]) {
      thumbBtns[idx].classList.add('is-active');
      currentThumbIdx = idx;
    }
  }

  thumbBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = parseInt(btn.dataset.thumbIdx, 10);
      var src = btn.dataset.thumbSrc;
      swapMainImage(src, idx);
    });
  });

  /* ─── Lightbox ──────────────────────────────────────────────────────── */
  var lightbox       = document.getElementById('pdp-lightbox');
  var lightboxImg    = document.getElementById('pdp-lightbox-img');
  var lightboxClose  = document.getElementById('pdp-lightbox-close');
  var lbSidebar      = document.getElementById('pdp-lightbox-sidebar');
  var lbBottom       = document.getElementById('pdp-lightbox-bottom');
  var lbBodyEl       = document.getElementById('pdp-lightbox-body');
  var lbThumbBtns    = Array.from(document.querySelectorAll('[data-lb-idx]'));
  var lbCurrentIdx   = 0;
  var touchStartX    = null;

  function openLightbox(idx) {
    if (!lightbox || images.length === 0) return;
    lbCurrentIdx = idx || currentThumbIdx;
    lightboxImg.src = images[lbCurrentIdx] ? images[lbCurrentIdx].src : '';
    lightboxImg.alt = images[lbCurrentIdx] ? images[lbCurrentIdx].alt || '' : '';
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    updateLbThumbs();
    scrollLbThumb();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.body.style.overflow = '';
  }

  function goLightbox(idx) {
    if (images.length === 0) return;
    lbCurrentIdx = (idx + images.length) % images.length;
    lightboxImg.src = images[lbCurrentIdx].src;
    lightboxImg.alt = images[lbCurrentIdx].alt || '';
    updateLbThumbs();
    scrollLbThumb();
  }

  function updateLbThumbs() {
    lbThumbBtns.forEach(function (b) {
      var idx = parseInt(b.dataset.lbIdx, 10);
      b.classList.toggle('is-active', idx === lbCurrentIdx);
    });
  }

  function scrollLbThumb() {
    var activeThumb = document.querySelector('[data-lb-idx="' + lbCurrentIdx + '"]');
    if (activeThumb) activeThumb.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
  }

  /* Main image click */
  var mainWrap = document.getElementById('pdp-main-wrap');
  if (mainWrap) {
    mainWrap.addEventListener('click', function () { openLightbox(currentThumbIdx); });
  }

  /* Close */
  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
  }

  /* Keyboard */
  document.addEventListener('keydown', function (e) {
    if (!lightbox || lightbox.hidden) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') goLightbox(lbCurrentIdx - 1);
    if (e.key === 'ArrowRight') goLightbox(lbCurrentIdx + 1);
  });

  /* Touch swipe in lightbox */
  if (lbBodyEl) {
    lbBodyEl.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    lbBodyEl.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var delta = e.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(delta) < 50) return;
      goLightbox(delta < 0 ? lbCurrentIdx + 1 : lbCurrentIdx - 1);
    });
  }

  /* Lightbox thumbnails */
  lbThumbBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var idx = parseInt(btn.dataset.lbIdx, 10);
      goLightbox(idx);
    });
  });

  /* ─── Variant options ───────────────────────────────────────────────── */
  var optionBtns = Array.from(document.querySelectorAll('[data-option-index]'));

  optionBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = parseInt(btn.dataset.optionIndex, 10);
      var val = btn.dataset.optionValue;

      selectedOptions[idx] = val;

      /* Update active state within this option group */
      optionBtns.forEach(function (b) {
        if (parseInt(b.dataset.optionIndex, 10) === idx) {
          b.classList.toggle('is-active', b.dataset.optionValue === val);
          b.setAttribute('aria-pressed', b.dataset.optionValue === val ? 'true' : 'false');
        }
      });

      /* Update selected value label */
      var selectedLabel = document.querySelector('[data-option-selected="' + idx + '"]');
      if (selectedLabel) selectedLabel.textContent = val;

      var match = findVariant();
      if (match) updateForVariant(match);
    });
  });

  /* ─── Quantity stepper ──────────────────────────────────────────────── */
  var qtyInput = document.querySelector('[data-qty-input]');
  var qtyMinus = document.querySelector('[data-qty-minus]');
  var qtyPlus  = document.querySelector('[data-qty-plus]');
  var atcPrice = document.getElementById('pdp-atc-price');

  function updateQtyButtons() {
    if (qtyMinus) qtyMinus.disabled = currentQty <= 1;
  }

  function setQty(val) {
    currentQty = Math.max(1, val);
    if (qtyInput) qtyInput.value = currentQty;
    updateQtyButtons();
    var match = findVariant();
    if (atcPrice && match) atcPrice.textContent = formatMoney(match.price * currentQty);
  }

  if (qtyMinus) qtyMinus.addEventListener('click', function () { setQty(currentQty - 1); });
  if (qtyPlus)  qtyPlus.addEventListener('click', function () { setQty(currentQty + 1); });
  if (qtyInput) {
    qtyInput.addEventListener('change', function () { setQty(parseInt(this.value, 10) || 1); });
  }

  /* ─── AJAX Add-to-Cart ──────────────────────────────────────────────── */
  var pdpForm    = document.getElementById('pdp-form');
  var toast      = document.getElementById('pdp-toast');
  var toastText  = document.getElementById('pdp-toast-text');
  var cartActions = document.getElementById('pdp-cart-actions');
  var atcBtn     = document.getElementById('pdp-atc-btn');
  var atcLabel   = document.getElementById('pdp-atc-label');
  var isAdding   = false;
  var toastTimer = null;

  function showToast(msg, isError) {
    if (!toast) return;
    toastText.textContent = msg;
    toast.className = 'pdp-card__toast' + (isError ? ' pdp-card__toast--error' : ' pdp-card__toast--ok');
    toast.hidden = false;
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 3500);
  }

  function updateCartCount(count) {
    var badge = document.querySelector('.header__cart-count');
    if (badge) {
      badge.textContent = String(count);
      badge.setAttribute('data-has-items', count > 0 ? 'true' : 'false');
    }
  }

  if (pdpForm) {
    pdpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (isAdding) return;
      isAdding = true;
      if (atcLabel) atcLabel.textContent = 'Wird hinzugefügt...';
      if (atcBtn) atcBtn.disabled = true;

      var formData = new FormData(pdpForm);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (res) { return res.json(); })
      .then(function (cartData) {
        var match = findVariant();
        var title = document.querySelector('.pdp-card__title');
        showToast((title ? title.textContent.trim() : 'Produkt') + ' wurde zum Warenkorb hinzugefügt!', false);
        updateCartCount(cartData.item_count);
        if (cartActions && cartData.item_count > 0) cartActions.hidden = false;
        if (match) updateForVariant(match);
        if (atcLabel) atcLabel.textContent = 'In den Warenkorb';
        if (atcBtn) atcBtn.disabled = false;
      })
      .catch(function () {
        showToast('Fehler beim Hinzufügen zum Warenkorb.', true);
        var match = findVariant();
        if (atcLabel) atcLabel.textContent = match && match.available ? 'In den Warenkorb' : 'Ausverkauft';
        if (atcBtn) atcBtn.disabled = match ? !match.available : false;
      })
      .finally(function () { isAdding = false; });
    });
  }

  /* ─── Collapsible description ───────────────────────────────────────── */
  var descBody   = document.getElementById('pdp-desc-body');
  var descFade   = document.getElementById('pdp-desc-fade');
  var descToggle = document.getElementById('pdp-desc-toggle');
  var descLabel  = document.getElementById('pdp-desc-toggle-label');
  var descChevron = document.getElementById('pdp-desc-chevron');
  var descOpen   = false;

  if (descToggle && descBody) {
    descToggle.addEventListener('click', function () {
      descOpen = !descOpen;
      descBody.dataset.collapsed = descOpen ? 'false' : 'true';
      if (descFade) descFade.hidden = descOpen;
      if (descLabel) descLabel.textContent = descOpen ? 'Weniger anzeigen' : 'Mehr anzeigen';
      if (descChevron) descChevron.style.transform = descOpen ? 'rotate(180deg)' : 'rotate(0deg)';
    });
  }

  /* ─── Payment logos toggle ──────────────────────────────────────────── */
  var paymentsMore   = document.getElementById('pdp-payments-more');
  var paymentsToggle = document.getElementById('pdp-payments-toggle');
  var paymentsLabel  = document.getElementById('pdp-payments-toggle-label');
  var paymentsChevron = document.getElementById('pdp-payments-chevron');
  var paymentsOpen   = false;

  if (paymentsToggle && paymentsMore) {
    paymentsMore.hidden = true;
    paymentsToggle.addEventListener('click', function () {
      paymentsOpen = !paymentsOpen;
      paymentsMore.hidden = !paymentsOpen;
      if (paymentsLabel) paymentsLabel.textContent = paymentsOpen ? 'Weniger anzeigen' : 'Weitere anzeigen';
      if (paymentsChevron) paymentsChevron.style.transform = paymentsOpen ? 'rotate(180deg)' : 'rotate(0deg)';
    });
  }

  /* ─── "Passend dazu" bundle rows ───────────────────────────────────── */
  var bundleRows = Array.from(document.querySelectorAll('[data-bundle-row]'));

  function bundleMoney(cents) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  function updateBundleRow(row, price, compare, available) {
    var priceEl = row.querySelector('[data-bundle-price]');
    var compareEl = row.querySelector('[data-bundle-compare]');
    var saveEl = row.querySelector('[data-bundle-save]');
    var addBtn = row.querySelector('[data-bundle-add]');

    if (priceEl) priceEl.textContent = bundleMoney(price);
    var hasDisc = compare && compare > price;
    if (compareEl) {
      compareEl.style.display = hasDisc ? '' : 'none';
      if (hasDisc) compareEl.textContent = 'Statt ' + bundleMoney(compare);
    }
    if (saveEl) {
      saveEl.style.display = hasDisc ? '' : 'none';
      if (hasDisc) saveEl.textContent = '-' + Math.round((1 - price / compare) * 100) + '%';
    }
    if (addBtn) {
      addBtn.disabled = !available;
      addBtn.textContent = available ? 'Hinzufügen' : 'Ausverkauft';
    }
  }

  bundleRows.forEach(function (row) {
    var select = row.querySelector('[data-bundle-select]');
    var minus = row.querySelector('[data-bundle-minus]');
    var plus = row.querySelector('[data-bundle-plus]');
    var qtyInput = row.querySelector('[data-bundle-qty]');
    var addBtn = row.querySelector('[data-bundle-add]');

    function getRowQty() {
      return Math.max(1, parseInt(qtyInput.value, 10) || 1);
    }

    function setRowQty(val) {
      val = Math.max(1, val);
      qtyInput.value = val;
      if (minus) minus.disabled = val <= 1;
    }

    if (select) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        var price = parseInt(opt.dataset.price, 10);
        var compare = parseInt(opt.dataset.compare, 10);
        var available = opt.dataset.available === 'true';
        row.dataset.variantId = opt.value;
        row.dataset.price = price;
        row.dataset.compare = compare;
        row.dataset.available = String(available);
        updateBundleRow(row, price, compare, available);
      });
    }

    if (minus) minus.addEventListener('click', function () { setRowQty(getRowQty() - 1); });
    if (plus) plus.addEventListener('click', function () { setRowQty(getRowQty() + 1); });
    if (qtyInput) qtyInput.addEventListener('change', function () { setRowQty(parseInt(qtyInput.value, 10) || 1); });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var variantId = row.dataset.variantId;
        if (!variantId || addBtn.disabled) return;

        addBtn.disabled = true;
        var original = addBtn.textContent;
        addBtn.textContent = 'Wird hinzugefügt...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: variantId, quantity: getRowQty() })
        })
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (res) { return res.json(); })
        .then(function (cartData) {
          var name = 'Produkt';
          var productName = row.querySelector('.bundle-row__title');
          if (productName) name = productName.textContent.trim();
          showToast(name + ' wurde zum Warenkorb hinzugefügt!', false);
          updateCartCount(cartData.item_count);
          if (cartActions && cartData.item_count > 0) cartActions.hidden = false;
          addBtn.textContent = 'Hinzugefügt ✓';
          setTimeout(function () {
            addBtn.textContent = original;
            addBtn.disabled = row.dataset.available === 'false';
          }, 2000);
        })
        .catch(function () {
          showToast('Fehler beim Hinzufügen zum Warenkorb.', true);
          addBtn.textContent = original;
          addBtn.disabled = row.dataset.available === 'false';
        });
      });
    }
  });

  /* ─── Initial state ─────────────────────────────────────────────────── */
  updateQtyButtons();

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-preview"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-preview]');
    if (!root) return;

    const scroller = root.querySelector('[data-preview-scroller]');
    const track = root.querySelector('[data-preview-track]');
    const prevBtn = root.querySelector('.js-preview-prev');
    const nextBtn = root.querySelector('.js-preview-next');
    const dotsWrap = root.querySelector('[data-preview-dots]');

    if (!scroller || !track) return;

    const count = Number(root.getAttribute('data-preview-count') || 0);
    const cards = () => Array.from(track.querySelectorAll('.product-card'));
    const mqDesktop = window.matchMedia('(min-width: 1024px)');

    let activeIndex = 0;
    let scrubbing = false;
    let startX = 0;
    let startIndex = 0;
    const pxPerSlide = 35;

    function updateArrows() {
      const max = scroller.scrollWidth - scroller.clientWidth;
      if (prevBtn) prevBtn.disabled = scroller.scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = scroller.scrollLeft >= max - 1;
    }

    function goTo(index) {
      const items = cards();
      if (!items.length) return;
      const clamped = Math.max(0, Math.min(items.length - 1, index));
      activeIndex = clamped;
      scrollToCard(items[clamped]);
      updateArrows();
      updateActiveDot();
    }

    function scrollToCard(el) {
      const target = mqDesktop.matches
        ? el.offsetLeft
        : el.offsetLeft - (scroller.clientWidth - el.offsetWidth) / 2;
      scroller.scrollTo({ left: target, behavior: 'smooth' });
    }

    function updateActiveDot() {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('[data-preview-dot]').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === activeIndex);
      });

      // Aktif kartı vurgula.
      cards().forEach((card, i) => {
        card.classList.toggle('is-active', i === activeIndex);
      });
    }

    // Build pill dots
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (let i = 0; i < count; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'preview__dot';
        dot.setAttribute('data-preview-dot', String(i));
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.addEventListener('click', () => goTo(i));
        dotsWrap.appendChild(dot);
      }
    }

    // Track active index on scroll
    function updateActiveFromScroll() {
      const items = cards();
      if (!items.length) return;
      const center = scroller.scrollLeft + scroller.clientWidth / 2;
      let best = 0;
      let bestDist = Infinity;
      items.forEach((el, i) => {
        const c = el.offsetLeft + el.offsetWidth / 2;
        const d = Math.abs(c - center);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      if (activeIndex !== best) {
        activeIndex = best;
        updateDotsOnly();
      }
    }

    function updateDotsOnly() {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('[data-preview-dot]').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === activeIndex);
      });

      // Aktif kartı vurgula (React: yan kartlar küçük/soluk, ortadaki belirgin).
      cards().forEach((card, i) => {
        card.classList.toggle('is-active', i === activeIndex);
      });
    }

    // Arrows
    if (prevBtn) {
      prevBtn.addEventListener('click', () => goTo(activeIndex - 1));
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => goTo(activeIndex + 1));
    }

    // Dot-bar scrub (mobile/tablet)
    if (dotsWrap) {
      dotsWrap.addEventListener('pointerdown', (e) => {
        scrubbing = true;
        startX = e.clientX;
        startIndex = activeIndex;
        dotsWrap.setPointerCapture(e.pointerId);
      });
      dotsWrap.addEventListener('pointermove', (e) => {
        if (!scrubbing) return;
        const delta = e.clientX - startX;
        goTo(startIndex + Math.round(delta / pxPerSlide));
      });
      dotsWrap.addEventListener('pointerup', (e) => {
        scrubbing = false;
        dotsWrap.releasePointerCapture(e.pointerId);
      });
      dotsWrap.addEventListener('pointercancel', () => { scrubbing = false; });
    }

    let scrollTicking = false;
    scroller.addEventListener('scroll', () => {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(() => {
        updateArrows();
        updateActiveFromScroll();
        scrollTicking = false;
      });
    }, { passive: true });

    window.addEventListener('resize', () => { updateArrows(); });

    // Track add-to-cart analytics (same event as theme global)
    document.addEventListener('cart:item-added', (event) => {
      const detail = event.detail || {};
      if (detail.variant_id && window.ttq) {
        window.ttq.track('AddToCart', { content_id: detail.variant_id });
      }
      if (detail.variant_id && window.fbq) {
        window.fbq('track', 'AddToCart', { content_ids: [detail.variant_id] });
      }
    });

    buildDots();
    updateArrows();
    updateActiveDot();
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-stats-bar]');
    if (!root) return;

    function parseTarget(text) {
      if (!text) return null;
      const normalized = text.trim().replace(/\./g, '').replace(',', '.');
      const n = Number(normalized);
      return Number.isFinite(n) ? n : null;
    }

    const items = Array.from(root.querySelectorAll('.stats__item')).map((item) => {
      const numberEl = item.querySelector('.stats__number');
      const target = numberEl ? parseTarget(numberEl.textContent) : null;
      return { item, numberEl, target, suffixText: numberEl ? numberEl.textContent.trim() : '' };
    });

    if (!items.some((x) => x.target !== null)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.disconnect();

          items.forEach((x, i) => {
            x.item.classList.add('is-visible');
            if (x.target === null) return;

            const duration = 1800 - i * 150;
            const start = performance.now();

            function tick(now) {
              const progress = Math.min((now - start) / Math.max(duration, 400), 1);
              const eased = progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
              const value = Math.round(eased * x.target);
              x.numberEl.textContent = value.toLocaleString('de-DE');
              if (progress < 1) requestAnimationFrame(tick);
            }

            requestAnimationFrame(tick);
          });
        });
      },
      { threshold: 0.2 },
    );

    observer.observe(root);
  })();

  } catch(e) { console.error(e); }
})();
})();
